import React from 'react';
import { projects } from '../data';
import './Projects.css';

const ProjectCard = ({ project }) => {
  return (
    <div className={`project-card ${project.featured ? 'featured' : ''}`}>
      <div className="project-header">
        <span className={`project-status ${project.status === 'In Production' ? 'in-use' : ''}`}>
          {project.status}
        </span>
      </div>
      <div className="project-content">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <div className="project-tech">
          {project.tech.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="project-metrics">
          {project.metrics.map((metric, index) => (
            <span key={index} className="metric">{metric}</span>
          ))}
        </div>
        <a 
          href={project.link} 
          className="view-project-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Project →
        </a>
      </div>
    </div>
  );
};

const Projects = () => {
  return (
    <section className="projects" id="projects">
      <div className="section-header">
        <div>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">AI, Finance & Blockchain solutions</p>
        </div>
      </div>

      <div className="project-grid">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
